
import PropTypes from 'prop-types';
import { TableRow, TableCell, Checkbox, Avatar, Button, ListItemText, Table, Tooltip, MenuItem } from "@mui/material";
import CustomPopover, { usePopover } from '../../components/custom-popover/index.js';
import Iconify from "src/components/iconify/iconify.js";
// import { ConfirmDialog } from '../../components/custom-dialog/index.js';
import { useBoolean } from '../../hooks/use-boolean.js';
import { parseISO, format } from 'date-fns';

export default function SubscriptionTableRow({
    row, selected, onSelected, onDeleteRow, onEditRow, onViewRow, onSelectRow
}) {
    const { totalConfirmedClasses, diskSizeMB, databaseName, confirmedTraineesByMonth } = row;
    const popover = usePopover();
    const confirm = useBoolean();


    return (
        <>
            <TableRow hover selected={selected}>

                <TableCell sx={{ whiteSpace: 'nowrap' }}>{databaseName}</TableCell>

                <TableCell sx={{ whiteSpace: 'nowrap' }}>{confirmedTraineesByMonth[1]}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{confirmedTraineesByMonth[2]}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{confirmedTraineesByMonth[3]}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{confirmedTraineesByMonth[4]}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{confirmedTraineesByMonth[5]}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{confirmedTraineesByMonth[6]}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{confirmedTraineesByMonth[7]}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{confirmedTraineesByMonth[8]}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{confirmedTraineesByMonth[9]}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{confirmedTraineesByMonth[10]}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{confirmedTraineesByMonth[11]}</TableCell>
                 <TableCell sx={{ whiteSpace: 'nowrap' }}>{confirmedTraineesByMonth[12]}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{totalConfirmedClasses}</TableCell>
               <TableCell sx={{ whiteSpace: 'nowrap' }}>{diskSizeMB}</TableCell>
            </TableRow>
            <CustomPopover
                open={popover.open}
                onClose={popover.onClose}
                arrow="right-top"
                sx={{ width: 180 }}
            >
                <MenuItem onClick={onViewRow}>
                    <Iconify icon="pajamas:eye" />
                    View
                </MenuItem>
                <MenuItem onClick={onEditRow}>
                    <Iconify icon="solar:pen-bold" />
                    Update
                </MenuItem>

                <MenuItem onClick={() => {
                    confirm.onTrue();
                    popover.onClose();
                }} sx={{ color: 'error.main' }}>
                    <Iconify icon="solar:trash-bin-trash-bold" />
                    Delete
                </MenuItem>



            </CustomPopover>

            {/* <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content={`Are you sure want to delete ${title}?`}
        action={
          <Button variant="contained" color="error" onClick={onDeleteRow}>
            Delete
          </Button>
        }
      /> */}

        </>
    )

}

SubscriptionTableRow.propTypes = {
    onViewRow: PropTypes.func,
};
